import { createMutationHook } from '~/shared/providers/api';

export const useDeleteTruckMutation = createMutationHook(
  'transportation.truckDelete',
  (params: { id: string }) => ({
    transportationTruckDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
